import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, map, of, throwError } from 'rxjs';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const login = () => {
    authService.rememberReturnUrl(state.url);
    return router.createUrlTree(['/login']);
  };

  return authService.getUser().pipe(
    map(user => {
      if (user) {
        return true;
      }
      return login();
    }),
    catchError(error => error instanceof HttpErrorResponse && error.status === 401
      ? of(login())
      : throwError(() => error)),
  );
};
